import { Flex, Text } from '@chakra-ui/react'

import { pluralize } from '@/utils/helpers'

const CharacterCount: React.FC<{
  min?: number | null
  max?: number | null
  length: number
}> = ({ min, max, length }) => {
  const tooShort = min != null && length < min
  const tooLong = max != null && length > max

  return (
    <Flex justifyContent="space-between" columnGap={1}>
      <Text
        color="fg.error"
        transition="opacity 0.2s ease"
        opacity={tooShort || tooLong ? 1 : 0}
        variant="supporting"
      >
        {tooShort ? `Response must be at least ${pluralize(min, 'character')}` : ''}
        {tooLong ? `Response must be at most ${pluralize(max, 'character')}` : ''}
      </Text>
      {min != null || max != null ? (
        <Text color="fg.subtle" variant="supporting">
          {length}
          {max != null ? `/${max}` : null}
        </Text>
      ) : null}
    </Flex>
  )
}
export default CharacterCount
